import { createSelector } from '@reduxjs/toolkit';
import type { List as ImmutableList, Map as ImmutableMap } from 'immutable';

import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { scheduledTransactionsSelectors } from 'app-components/flux/scheduled-transactions';
import type { transactionsTypes } from 'app-components/flux/transactions';
import { transactionsSelectors, transactionsUtils } from 'app-components/flux/transactions';

// determine if this transaction has the given cat id in it
export const txnHasCategoryId = (txn: transactionsTypes.TransactionRecord, categoryIds: ImmutableList<string>) =>
  transactionsUtils.isSplitTxn(txn)
    ? Boolean(txn.split?.items?.find((item) => Boolean(item.coa && categoryIds.find((id) => item.coa?.id === id))))
    : txn.coa && Boolean(categoryIds.find((id) => txn.coa?.id === id));

export const getTxnsMatchingPredicate: (
  state: any,
  predicate: any,
) => [
  ImmutableList<transactionsTypes.TransactionRecord>,
  ImmutableList<scheduledTransactionsTypes.ScheduledTransaction>,
] = createSelector(
  (_state, predicate) => predicate,
  transactionsSelectors.getResourcesById,
  scheduledTransactionsSelectors.getUserVerifiedScheduledTransactions,
  (
    predicate,
    txnsById: ImmutableMap<string, transactionsTypes.TransactionRecord>,
    scheduledTxnsById: ImmutableMap<string, scheduledTransactionsTypes.ScheduledTransaction>,
  ) => {
    const matchedTxns = txnsById
      .filter((txn) => !transactionsUtils.isUnacceptedScheduledTxn(txn) && predicate(txn))
      .toList();
    const matchedScheduledTxns = scheduledTxnsById
      .filter((scheduledTxn) => predicate(scheduledTxn.transaction))
      .toList();

    return [matchedTxns, matchedScheduledTxns];
  },
);
